/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";


export const prepareApiRequestHeaders = (AUTH_TOKEN: AUTHORIZATION_TOKEN_INTERFACE | null = null): HeadersInit => {


    const REQUEST_HEADERS: HeadersInit = new Headers();

    for (let [headerName, headerValue] of Object.entries(DEFAULT_REQUEST_HEADERS)) {
        REQUEST_HEADERS.append(headerName, headerValue);
    }

    if (AUTH_TOKEN?.tokenValue) {
        REQUEST_HEADERS.append("Authorization", AUTH_TOKEN?.tokenValue);
    }

    return REQUEST_HEADERS;

};


export default prepareApiRequestHeaders;
